<template>
  <!-- Visible photo -->
  <a rel="nofollow, noindex"
     data-lightbox="images"
     :href="photo.file.lgUrl"
     class="photo-link">
    <img loading="lazy"
         decoding="async"
         :alt="title"
         :title="title"
         class="photo-image"
         :src="photo.file.mdUrl">

    <!-- Hidden links for remaining photos in carousel (nested inside first photo link) -->
    <template v-if="index === 0">
      <a v-for="(hiddenPhoto, idx) in hiddenPhotos"
         :key="`hidden-${hiddenPhoto.id}`"
         rel="nofollow, noindex"
         data-lightbox="images"
         :href="hiddenPhoto.file.lgUrl"
         style="display: none; position: absolute;">
      </a>
    </template>
  </a>
</template>

<script>

export default {
  props: {
    photo: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
    allPhotos: {
      type: Array,
      required: false,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    fetchUnprocessed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hiddenPhotos() {
      // Only the first photo of each comment should render all hidden photos
      // This ensures the lightbox carousel has access to all images
      if (this.index === 0 && this.allPhotos.length > 1) {
        return this.allPhotos.slice(1);
      }
      return [];
    },
  },
};
</script>

<style scoped>
.photo-link {
  display: block;
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.photo-link:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.photo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  border-radius: 8px;
}

/* Responsive sizing */
@media (max-width: 576px) {
  .photo-link {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 380px) {
  .photo-link {
    width: 70px;
    height: 70px;
  }
}
</style>
